$(document).ready(function () {

    var bindEvents = function () {
        $('a.js-page').click(function () {
            var pageNumber = $(this).data("page");
            filterEvents(pageNumber);
        });
    };

    $('.js-checkbox').click(function () {
        clearTimeout(eventFilterTimeout);
        eventFilterTimeout = setTimeout(function () {
            filterEvents(1);
        }, 2000);
    });

    var eventFilterTimeout;

    var filterEvents = function (gotoPage) {
        var _typeFilters = [], _regionFilters = [];
        $('.js-chkType:checked').each(function () {
            _typeFilters.push($(this).val());
        });
        $('.js-chkRegion:checked').each(function () {
            _regionFilters.push($(this).val());
        });

        $.ajax({
            url: window.location.href,
            type: "POST",
            context: this,
            data: {
                scController: "EventSearch", scAction: "FilterEvents", criteria: {
                    EventType: _typeFilters, EventRegion: _regionFilters, Page: gotoPage, SearchRoot : $('#eventSearchRoot').val() }
            },
            success: function (_results) {

                $("#grid-pagination").replaceWith(_results.Pagination);
                $("#event-grid-header").replaceWith(_results.Header);
                $("#event-card-grid").replaceWith(_results.SearchResults);
                bindEvents();

            }
        });
    };
    bindEvents();
    
});